<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >

        <el-form-item label="提现方式" required prop="channelTypeText">
          <el-input v-model="form.channelTypeText" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="手续费率" required prop="fee_rate">
          <el-input v-model="form.fee_rate">
           <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <el-form-item label="起提金额" required prop="base_amount">
          <el-input v-model="form.base_amount"/>
        </el-form-item>

        <el-form-item label="提现倍数" required prop="multiple">
          <el-input v-model="form.multiple"/>
        </el-form-item>

        <el-form-item label="提现上限" required prop="upper_limit">
          <el-input v-model="form.upper_limit"/>
        </el-form-item>

      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import {
  editWithdrawalCfg,
  updateWithdrawalCfg,
  storeWithdrawalCfg,
  createWithdrawalCfg,
} from '@/api/withdrawal-cfgs'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
          fee_rate: '',
          base_amount: '',
          multiple: '',
          upper_limit: '',
          channelTypeText: '',
      },
      errors: {},
    }
  },
  methods: {
    async getData() {
      let data

      if (this.editMode) {
        ({ data } = await editWithdrawalCfg(this.resourceId))
        this.fillForm(data)
      } else {
        ({ data } = await createWithdrawalCfg())
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateWithdrawalCfg(this.resourceId, this.form)
      } else {
        await storeWithdrawalCfg(this.form)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
